
import './qualityInpection.css';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, NavItem, Table} from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert';
import {QualityInspectionPopUP} from "./qualityInspectionPopUP";
import { PROD } from '../../../common/constants';

function QualityInspection(){

    const navigate = useNavigate();

    const qualityInspectionEdit= (e) => {
        e.preventDefault();
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <QualityInspectionPopUP onClose={onClose} />
                );
            }
        });
    
    }

    return(
        <div>
            <Container fluid>
                <Row>
                    {/* <Col xs={12} md={3} className='common-internal-sidebar-col'>
                      <div className="common-internal-sidebar-container">
                        <ArrowBackIosNew className="arrow-icon" onClick={() => (navigate('/dashboardStakeHolder'))} />
                      </div>                  
                    </Col> */}
                    <Col xs={12} md={12}>
                        <div>
                        {!PROD &&   <p style={{textAlign:"center", fontSize:"2vh"}}>PIT41</p>}
                            <form>
                               <Container fluid>
                               <div className='headingStylePIT'>Location Inventory Inspection</div>
                                 <Row>
                                 <Col xs={12} md={4}>
                                       <div className="consignment-pick-up-consignment-label" >Select Inventory Type</div>
                                       <select className='consignment-pick-up-textfields'>
                                            <option>Select</option>
                                            <option>Raw Bamboo</option>
                                            <option>Chipped Bamboo</option>
                                        </select>
                                        <div className="consignment-pick-up-consignment-label">Inspection Order Number</div>
                                        <input className='consignment-pick-up-textfields' type="text" maxLength={20}/>
                                   </Col>
                                   <Col xs={12} md={4}>
                                       <div className="consignment-pick-up-consignment-label">Select Inventory Inspection Type</div>
                                       <select className='consignment-pick-up-textfields'>
                                            <option>Select</option>
                                            <option>Un-Restricted</option>
                                            <option>Restricted</option>
                                            <option>Scrap</option>
                                        </select> 
                                    </Col>  
                                    <button className='quality-inspection-generate-submit-btn' type='submit'>Generate Inspection Order</button>
                                </Row>
                               </Container>   
                               <br></br>                         
                               <Container fluid>
                                <Row>
                                  <Col xs={12} md={12}>
                                     <div className='common-table-div'>
                                        <Table responsive className="common-table" striped>
                                          <thead>      
                                            <tr>
                                                <th rowSpan={2}  className='common-table-heading-text common-table-border'>RB Bundle ID/CB Entries</th>
                                                <th colspan="3" scope="colgroup" className="common-table-border">Pre-Inspection</th>
                                                <th colspan="5" scope="colgroup" className="common-table-border">Post-Inspection</th>
                                                <th rowSpan={2}  className='common-table-heading-text common-table-border'>Action</th>

                                            </tr>
                                            <tr>
                                                <th  className='common-table-heading-text common-table-border-right'>Date Of Entry</th>
                                                <th  className='common-table-heading-text common-table-border-right'>Moisture</th>
                                                <th className='common-table-heading-text common-table-border-right'>Weight</th>
                                                <th  className='common-table-heading-text common-table-border-right'>Moisture</th>
                                                <th  className='common-table-heading-text common-table-border-right'>Weight</th>
                                                <th  className='common-table-heading-text common-table-border-right'>Un-Restricted Inventory</th>
                                                <th  className='common-table-heading-text common-table-border-right'>Restricted Inventory</th>
                                                <th  className='common-table-heading-text common-table-border-right'>Scrap Inventory</th>    
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                                <td className='common-table-text'>RB001</td>
                                                <td className='common-table-text'>20/12/2022</td>
                                                <td className='common-table-text'>10</td>
                                                <td className='common-table-text'>150</td>
                                                <td className='common-table-text'>20</td>
                                                <td className='common-table-text'>200</td> 
                                                <td className='common-table-text'>100</td>
                                                <td className='common-table-text'>300</td>
                                                <td className='common-table-text'>150</td>
                                                <td><input type="button" className="quality-inspection-edit-btn" value="Edit" onClick={(e)=>qualityInspectionEdit(e)}></input></td>
                                            </tr>
                                            <tr>
                                                <td className='common-table-text'>RB002</td>
                                                <td className='common-table-text'>10/11/2022</td>
                                                <td className='common-table-text'>20</td>
                                                <td className='common-table-text'>350</td>
                                                <td className='common-table-text'>40</td>
                                                <td className='common-table-text'>500</td> 
                                                <td className='common-table-text'>900</td>
                                                <td className='common-table-text'>100</td>
                                                <td className='common-table-text'>50</td>
                                                <td><input type="button" className="quality-inspection-edit-btn" value="Edit" onClick={(e)=>qualityInspectionEdit(e)}></input></td>
                                            </tr>
                                            <tr>
                                                <td className='common-table-text'>RB003</td>
                                                <td className='common-table-text'>26/10/2022</td>
                                                <td className='common-table-text'>50</td>
                                                <td className='common-table-text'>60</td>
                                                <td className='common-table-text'>40</td>
                                                <td className='common-table-text'>110</td> 
                                                <td className='common-table-text'>340</td>
                                                <td className='common-table-text'>700</td>
                                                <td className='common-table-text'>430</td>
                                                <td><input type="button" className="quality-inspection-edit-btn" value="Edit"onClick={(e)=>qualityInspectionEdit(e)}></input></td>
                                            </tr>
                                          </tbody>
                                        </Table>
                                     </div>
                                  </Col>
                                </Row>
                               </Container> 
                               <Row>
                                <Col xs={12} md={2} col={12}>    
                                    <button className='complete-inventory-btn' type='submit'>Complete Inventory Inspection</button>
                                </Col>
                              </Row>  
                            </form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default QualityInspection;